import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import DatePicker from 'react-datepicker'
import { DateHandler } from 'utils'

/**
 * @param {{
 *    id: string
 *    name?: string
 *    className?: string
 *    disabled?: boolean
 *    onChange?: any
 *    onKeyDown?: any
 *    value?: any
 * }} props
 * @returns {React.Component}
 */
const ZariInputDate = ({ className, value, onChange, isInvalid, onKeyDown, ...props }) => {
  const selectedValue = React.useMemo(() => {
    let validValue = null
    if (value) {
      if (DateHandler.isValidString(value)) {
        validValue = DateHandler.parse(value)
      }
    }
    return validValue
  }, [value])

  return (
    <div onKeyDown={onKeyDown}>
      <DatePicker
        {...props}
        dateFormat='dd/MM/yyyy'
        selected={selectedValue}
        className={clsx(
          'form-control form-control-sm zr-form__control zr-form__input-date',
          {
            'is-invalid': isInvalid
          },
          className
        )}
        onChange={date => {
          const stringDate = date ? DateHandler.format(date) : ''
          onChange({
            target: {
              id: props.id,
              name: props.name,
              value: stringDate
            }
          })
        }}
        placeholderText='dd/mm/aaaa'
        autoComplete='off'
      />
    </div>
  )
}

ZariInputDate.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

export default ZariInputDate
